<template>
  <div id="main_con">
    <!--关闭页面的按钮-->
    <a class="close_img imgBlock" @click="close_web">
      <img src="../../assets/qixi/qixi(41).png" class="imgBlock noevents-img" />
    </a>
    <!-- 顶部动画区域 -->
    <xyAnima></xyAnima>

    <!-- 按钮切换区域 -->
    <div class="btn_main relativeItem flex-box">
      <div class="box_ac" @click="clickBtnFun(0)">
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/xy01.png"
          v-show="btnAc == 0"
        />
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/xy00.png"
          v-show="btnAc != 0"
        />
      </div>
      <div class="box_ac" @click="clickBtnFun(1)">
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/xyb01.png"
          v-show="btnAc == 1"
        />
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/xyb00.png"
          v-show="btnAc != 1"
        />
      </div>
      <div class="box_ac" @click="clickBtnFun(2)">
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/rolue01.png"
          v-show="btnAc == 2"
        />
        <img
          class="imgBlock noevents-img b_img"
          src="../../assets/xyuan/rolue00.png"
          v-show="btnAc != 2"
        />
      </div>
    </div>
    <div class="sec_box relativeItem">
      <!-- 内容主体 -->
      <div class="main_c">
        <div v-show="btnAc == 0">
          <xyYu :isStart="isStart"></xyYu>
        </div>
        <div v-show="btnAc == 1">
          <xyBcom ref="mychild" :isStart="isStart"></xyBcom>
        </div>
        <div v-show="btnAc == 2" class="rolue_con">
          <img
            class="imgBlock noevents-img rimg"
            src="../../assets/xyuan/rimg.png"
          />
        </div>
      </div>
      <div class="di_img">
        <img
          class="imgBlock noevents-img"
          src="../../assets/xyuan/tipbg3.png"
        />
      </div>

      <div class="sport_t">活动最终解释权归朱贝所有</div>
    </div>
  </div>
</template>











<script>
import xyYu from "./xy_yu";
import xyBcom from "./xy_bcom";
import xyAnima from "./xy_anima";

export default {
  name: "main_con",
  components: {
    xyYu,
    xyBcom,
    xyAnima,
  },
  data() {
    return {
      btnAc: 0,
      isStart: 0, //0未开始 1开始 2结束
      startTime: 0,
      endTime: 0,
      scrollTop: 0, //滚动的距离
    };
  },
  mounted() {
    this.$tool.setTitle("新语新愿");
    this.judgeStart();
  },

  beforeRouteLeave(to, from, next) {
    this.scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    window.removeEventListener("scroll", this.handleScroll);
    window.onscroll = null;
    next();
  },

  activated() {
    document.body.scrollTop = this.scrollTop;
  },

  methods: {
    // 判断活动是否开启
    judgeStart() {
      // 1月15时间戳  秒  1月18时间戳 1610985600
      let _this = this;
      this.$jsonp(this.$apis("xy_startTime"), {}, (res) => {
        _this.startTime = res.data.data.start_time;
        _this.endTime = res.data.data.end_time;
        let nowTime = _this.$tool.getTimeC();
        if (nowTime < _this.startTime) {
          _this.isStart = 0;
        } else if (nowTime >= _this.startTime && nowTime <= _this.endTime) {
          _this.isStart = 1; // 开始
        } else {
          _this.isStart = 2; //未开始
        }
      });
    },

    /**关闭webview */
    close_web() {
      this.$appAc.closeWeb();
    },

    // 按钮点击的切换
    clickBtnFun(idx) {
      this.btnAc = idx;
      if (idx == 1) {
        this.$refs.mychild.setOverShow();
      }
    },
  },
};
</script>











<style scoped>
.close_img {
  position: fixed;
  width: 9%;
  top: 8%;
  z-index: 19;
}

#main_con {
  width: 100%;
}
.sec_box {
  width: 100%;
  /* margin-top: -15px; */
  z-index: 10;
  background-color: #3c044b;
  padding: 0 0 60px;
}
.btn_main {
  width: 100%;
  justify-content: space-between;
  margin-top: -32px;
  padding: 0 4%;
  z-index: 3;
  background: url("../../assets/xyuan/bangrg.png") no-repeat;
  background-size: 100%;
}
.btn_main .b_img {
  margin: auto;
  width: 100%;
}
/* 内容主体区域 */
.main_c {
  width: 100%;
  background: url("../../assets/xyuan/tipbg2.png") left top repeat;
  background-size: 100%, 100%;
}
.b_x {
  color: #fff;
  width: 100%;
  text-align: center;
}
.rimg {
  width: 80%;
  margin: auto;
}
.rolue_con {
  padding: 16px 0 30px;
}
.sport_t {
  width: 100%;
  margin-top: 30px;
  text-align: center;
  color: #a631c5;
  font-size: 0.5625rem;
}
.di_img {
  margin-top: -22px;
}
</style>